<!-- Small and medium viewport -->
<div class="d-block d-lg-none">
    <mobile-status-info-table [tableData]="request" [displayedColumns]="columnsToDisplay"></mobile-status-info-table>
</div>

<!-- Large viewport -->
<div class="d-none d-lg-block">
    <desktop-status-info-table [tableData]="request" [displayedColumns]="columnsToDisplay"></desktop-status-info-table>
</div>